import baseStore from '../generic_store';

const base = baseStore('floors');

const state = {
    ...base.state,
    base_url: '/api/floors',
    resourceName: 'Étage',
    model: {
        name: null,
        description: {
            fr: null,
            en: null,
        },
        translatable: {
            description: {
                fr: null,
                en: null,
            }
        }
    },
};

const getters = {
    ...base.getters,
};

const actions = {
    ...base.actions,
};

const mutations = {
    ...base.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};

